<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSuiteClickToCall } from 'dashboard/composables/useSuiteClickToCall';

const props = defineProps({
  phoneNumber: { type: String, default: '' },
  size: { type: Number, default: 14 },
});

const { t } = useI18n();
const { canCall, isDialing, dial } = useSuiteClickToCall();

const visible = computed(() => canCall(props.phoneNumber));

const onClick = event => {
  event.preventDefault();
  event.stopPropagation();
  dial(props.phoneNumber);
};
</script>

<template>
  <button
    v-if="visible"
    type="button"
    class="inline-flex items-center justify-center flex-shrink-0 p-0.5 rounded text-n-teal-10 hover:text-n-teal-11 disabled:opacity-50"
    :disabled="isDialing"
    :title="t('INTEGRATION_APPS.SUITE.CLICK_TO_CALL.TOOLTIP')"
    @click="onClick"
  >
    <fluent-icon icon="call" :size="size" />
  </button>
</template>
